import React from "react";
import { Risk, RiskMitigation } from "./types";
import { calculatePerformanceLevel, plrStartingPoint } from "./utils";
import { Feature, useFeatureFlags } from "context/FeatureFlag";

interface PerformanceLevelScoreFormFieldProps {
  idx: number;
  risk: Risk;
  mitigations: RiskMitigation[];
}

export const PerformanceLevelScoreFormField = (
  props: PerformanceLevelScoreFormFieldProps
) => {
  const { isFeatureEnabled } = useFeatureFlags();

  if (!props.risk || !props.mitigations) {
    return null;
  }
  const currentMitigation = props.mitigations[props.idx];

  if (currentMitigation.type !== "ESS") {
    return null;
  }

  return (
    <div className="col-span-6">
      <div className="flex justify-between">
        <label className="block text-md font-medium text-gray-700">
          Performance Level Required <i>(PLR)</i> der Maßnahme:{" "}
          <b>
            {calculatePerformanceLevel(
              // `props.risk` carries the live, in-form values; `risk.assessment`
              // is only rebuilt from them on save and is stale while editing.
              plrStartingPoint(
                isFeatureEnabled!(Feature.PlrRelativeToMeasures),
                props.risk,
                props.mitigations,
                props.idx
              )
            )}
          </b>
        </label>
      </div>
    </div>
  );
};
